var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees-section"
  }, [(_vm.employees) ? _c('div', [_c('section', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-inputs"
  }, [_c('div', {
    staticClass: "loupe"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Forside",
      "transform": "translate(-129.000000, -591.000000)",
      "stroke": "#343638",
      "stroke-width": "2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Filter-employee",
      "transform": "translate(100.000000, 570.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Search",
      "transform": "translate(30.000000, 19.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icon:-Search",
      "transform": "translate(0.000000, 3.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.5,13.5 L19.5,19.5",
      "id": "Line",
      "fill": "#343638",
      "stroke-linecap": "square"
    }
  }), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "7.5",
      "cy": "7.5",
      "r": "7.5"
    }
  })])])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInputValue),
      expression: "searchInputValue"
    }],
    staticClass: "search-input",
    attrs: {
      "aria-label": _vm.inputPlaceholder,
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": (_vm.searchInputValue)
    },
    on: {
      "keyup": function($event) {
        _vm.filterData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInputValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "filters"
  }, _vm._l((_vm.filters), function(filter, filterSectionKey) {
    return (filterSectionKey !== 'positions') ? _c('div', {
      key: filterSectionKey,
      staticClass: "filter-section"
    }, [_c('svg', {
      staticClass: "drop",
      attrs: {
        "width": "15px",
        "height": "10px",
        "viewBox": "0 0 15 10",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('g', {
      attrs: {
        "id": "Page-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Arkiv-aktuelt",
        "transform": "translate(-704.000000, -283.000000)",
        "fill": "#000"
      }
    }, [_c('g', {
      attrs: {
        "id": "Filter-employee",
        "transform": "translate(540.000000, 260.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Icon:-Arrow",
        "transform": "translate(171.500000, 27.705882) rotate(270.000000) translate(-171.500000, -27.705882) translate(166.500000, 20.205882)"
      }
    }, [_c('polygon', {
      attrs: {
        "id": "Shape",
        "points": "9.16523618 2.078075 7.51817735 0.431016176 0.459353824 7.48983971 7.51817735 14.5486632 9.16523618 12.9016044 3.75347147 7.48983971"
      }
    })])])])])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.onFilterInputChange(filterSectionKey, _vm.selected)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.dropdownLable(filterSectionKey)))]), _vm._v(" "), _vm._l((filter), function(option) {
      return _c('option', {
        key: option.term_id,
        attrs: {
          "disabled": _vm.isOptionInUse(filterSectionKey, option.term_id)
        },
        domProps: {
          "value": option.term_id,
          "innerHTML": _vm._s(option.name)
        }
      })
    })], 2), _vm._v(" "), _c('ul', {
      staticClass: "selected-values"
    }, _vm._l((_vm.activeFilters[filterSectionKey]), function(id) {
      return _c('li', {
        key: 'sel-' + id
      }, [_c('span', {
        staticClass: "remove",
        on: {
          "click": function($event) {
            _vm.removeFilterValue(filterSectionKey, id)
          }
        }
      }, [_c('svg', {
        attrs: {
          "width": "9px",
          "height": "9px",
          "viewBox": "0 0 9 9",
          "version": "1.1",
          "xmlns": "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink"
        }
      }, [_c('g', {
        attrs: {
          "id": "Page-1",
          "stroke": "none",
          "stroke-width": "1",
          "fill": "none",
          "fill-rule": "evenodd"
        }
      }, [_c('g', {
        attrs: {
          "id": "Medarbeidere",
          "transform": "translate(-130.000000, -593.000000)",
          "fill": "#FFFFFF"
        }
      }, [_c('g', {
        attrs: {
          "id": "Group-12",
          "transform": "translate(100.000000, 443.000000)"
        }
      }, [_c('g', {
        attrs: {
          "id": "Group-11",
          "transform": "translate(0.000000, 60.000000)"
        }
      }, [_c('g', {
        attrs: {
          "id": "Group-10",
          "transform": "translate(30.000000, 30.000000)"
        }
      }, [_c('g', {
        attrs: {
          "id": "Group-8"
        }
      }, [_c('g', {
        attrs: {
          "id": "Group-3",
          "transform": "translate(0.000000, 53.000000)"
        }
      }, [_c('g', {
        attrs: {
          "id": "clear",
          "transform": "translate(0.000000, 7.000000)"
        }
      }, [_c('polygon', {
        attrs: {
          "id": "Shape",
          "points": "8.95721541 0.895721541 8.06149389 0 4.47860771 3.58288617 0.895721541 0 0 0.895721541 3.58288617 4.47860771 0 8.06149389 0.895721541 8.95721541 4.47860771 5.37432925 8.06149389 8.95721541 8.95721541 8.06149389 5.37432925 4.47860771"
        }
      })])])])])])])])])])]), _vm._v(" "), _c('span', {
        staticClass: "label",
        domProps: {
          "innerHTML": _vm._s(_vm.filterLabelById(filterSectionKey, id))
        }
      })])
    }))]) : _vm._e()
  })), _vm._v(" "), (_vm.filteredEmployees) ? _c('ul', {
    staticClass: "page-employees-rel clearfix"
  }, [_vm._l((_vm.filteredEmployees.slice(0, _vm.page * _vm.perPage)), function(employee) {
    return _c('li', {
      key: employee.id,
      staticClass: "cell"
    }, [_c('singleemployee', {
      attrs: {
        "postdata": employee
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "load-more-area"
  }, [_c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: ({
        callback: _vm.loadMoreVisible,
        throttle: 150,
      }),
      expression: "{\n                        callback: loadMoreVisible,\n                        throttle: 150,\n                    }"
    }],
    staticClass: "visibility-dot"
  }), _vm._v(" "), (_vm.filteredEmployees.length !== 0 && _vm.filteredEmployees.length > (_vm.page * _vm.perPage)) ? _c('button', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("LOAD MORE")]) : _vm._e()]), _vm._v(" "), (_vm.filteredEmployees.length === 0) ? _c('p', {
    staticClass: "no-results"
  }, [_vm._v(_vm._s(_vm.noResultsMessage))]) : _vm._e()], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.employees) ? _c('preloader') : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26708849","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/Employees.vue
// module id = 272
// module chunks = 0